<template>
  <div v-if="showSidebar">
    <b-card no-body class="sidebar">
      <h5 slot="header" class="sidebar-header">
        <span class="computed-title">
          {{ ls_LatestNews }}
          <span class="swiper-sidebar-control-btns">
            <i @click="prev()" class="fal fa-chevron-circle-left ctrl-btn ml-auto"></i>
            <i @click="next()" class="fal fa-chevron-circle-right ctrl-btn"></i>
          </span>
        </span><span class="triangle"></span>
      </h5>
      <swiper class="sidebar-swiper" :options="bannerOption" ref="qazlatynSidebar">
        <swiper-slide v-for="(itemGroup, n) in computedNews" :key="n">
          <div class="list-unstyled news-list">
            <template v-for="(news, index) in itemGroup.groupItem">
              <router-link
                :to="linkPrefix + news.url"
                :key="index"
                class="news-item-parent-link">
                <b-media
                  class="m-2 news-item"
                  tag="div">
                  <a slot="aside">
                    <b-img :src="host + news.thumbnailUrl" width="144" height="81" :alt="news.title" />
                  </a>
                  <h5 class="news-title">
                    <a class="news-link">
                      {{ news.title }}
                    </a>
                  </h5>
                  <p class="news-components">{{ news.addTimeMMddyyyyHHmm }} &nbsp;&nbsp; <i class="fas fa-eye"></i> {{ news.viewCount }}</p>
                </b-media>
              </router-link>
            </template>
          </div>
        </swiper-slide>
        
        <div ref="prevBtn" class="swiper-ctrlbtn-prev hidden" slot="button-prev"></div>
        <div ref="nextBtn" class="swiper-ctrlbtn-next hidden" slot="button-next"></div>
      </swiper>
      <b-card-footer class="text-right news-footer">
        <b-link :to="linkPrefix + newsListLink" class="news-more">{{ ls_More }} <i class="fas fa-chevron-circle-right"></i></b-link>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerOption: {
        autoplay: false,
        lazy: true,
        observer: true,
        loop: true,
        effect: "fade",
        navigation: {
          nextEl: '.swiper-ctrlbtn-next',
          prevEl: '.swiper-ctrlbtn-prev'
        }
      },
      banners: [],
      showSidebar: true,
      pageIndex: 1,
      pageSize: 20,
      newsCount: 0,
      newsList: [],
      newsListLink: "/article"
    };
  },

  computed: {
    computedNews() {
      let newsGroup = [];
      let groupItem = {};
      if (this.newsList.length > 0) {
        for(let i = 0; i < Math.ceil(this.newsList.length / 4); i++) {
          let end = i * 4 + 4 > this.newsList.length - 1 ? this.newsList.length : i * 4 + 4;
          groupItem = this.newsList.slice(i * 4, end);
          newsGroup.push({
            groupItem: groupItem
          });
        }
      }
      return newsGroup;
    },
    linkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },
    host() {
      return this.$store.state.host;
    },
    /**
     * These all for Language Pack
     */
    ls_LatestNews() {
      return this.$store.state.languagePack.ls_LatestNews;
    },

    ls_More() {
      return this.$store.state.languagePack.ls_More;
    }
  },

  created() {
    this.getArticleList(this.pageIndex, this.pageSize, null);
  },

  methods: {
    next() {
      if (this.$refs.nextBtn) {
        this.$refs.nextBtn.click();
      }
    },
    prev() {
      if (this.$refs.prevBtn) {
        this.$refs.prevBtn.click();
      }
    },
    getArticleList(pageIndex, pageSize) {
      this.showSidebar = false;
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("page", pageIndex);
      fd.append("pageSize", pageSize);
      this.$http
        .post(this.host + "/api/qazlatyn/getarticlelist", fd)
        .then(result => {
          this.showSidebar = true;
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.newsCount = result.body.data.total;
              this.newsList = result.body.data.dataList;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    concatArticleList(pageIndex, pageSize) {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("page", pageIndex);
      fd.append("pageSize", pageSize);
      this.$http
        .post(this.host + "/api/qazlatyn/getarticlelist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.newsCount = result.body.data.total;
              this.computedNews = this.computedNews.concat(
                result.body.data.dataList
              );
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }

    // infiniteHandler($state) {
    //   if (
    //     this.computedNews.length < 50 &&
    //     (this.computedNews.length <= this.pageSize ||
    //       this.computedNews.length < this.newsCount)
    //   ) {
    //     this.concatArticleList(this.pageIndex, this.pageSize, $state);
    //   } else {
    //     $state.complete();
    //   }
    // }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getArticleList(this.pageIndex, this.pageSize);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  border-radius: 0;
  border: 1px solid #dddfe2;
  border-top: 0;
  overflow: hidden;

  .card-header {
    border: 0;
    padding: 0;

    .sidebar-header {
      position: relative;
      border-top: 2px solid #008496;
      border-bottom: 1px solid #e1e1e1;
      background-color: #00849611;
      margin-bottom: 0;

      .computed-title {
        position: relative;
        display: inline-block;
        width: 100%;
        min-height: 1.875rem;
        padding: 8px 16px;
        font-size: 1.125rem;
        color: #333333;

        .swiper-sidebar-control-btns {
          float: right;
        }

        .ctrl-btn {
          margin: 0 2px;
          cursor: pointer;
          color: #757575;

          &:hover {
            color: #008490;
          }
        }
      }

      // .triangle {
      //   position: absolute;
      //   top: 0;
      //   display: inline-block;
      //   width: 0;
      //   height: 0;
      //   border-width: 1rem 0.5rem;
      //   border-style: solid;
      //   border-color: #f6f6f6 #f6f6f6 #008496 #008496;
      // }
    }
  }

  .news-list {
    padding-top: 0.4rem;
    margin-bottom: 0;
    overflow: hidden;
    background-color: #fff !important;
    min-height: 375px;

    .news-item-parent-link {
      text-decoration: none;
    }

    .news-item {
      padding: 0.35rem 1rem;
      margin: 0 !important;

      &:hover {
        background-color: #f0f8f9;
      }

      .news-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 15px;

        .news-link {
          text-decoration: none;
          line-height: 1.4;
          color: #333;
          text-decoration: none;
        }
      }

      .news-components {
        font-size: 12px;
        color: #b8b6b6;
        margin-top: -5px;
        margin-bottom: 0;
        cursor: default;
        text-decoration: none;
      }
    }
  }

  .news-footer {
    background-color: #ffffff;
    border-top: 0;
    padding: 0 1rem;
    padding-bottom: 0.5rem;

    .news-more {
      font-family: Arial, Helvetica, sans-serif;
      color: #008496;
      font-size: 0.75rem;
      font-weight: 500;
    }
  }
}

.scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  cursor: pointer !important;
}

.scrollbar::-webkit-scrollbar {
  width: 0.25rem;
  background-color: #f5f5f5;
  cursor: pointer !important;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: #777777;
  cursor: pointer !important;
  // background-image: -webkit-linear-gradient(
  //   90deg,
  //   #ffffff33 25%,
  //   transparent 25%,
  //   transparent 50%,
  //   rgba(255, 255, 255, 0.2) 50%,
  //   rgba(255, 255, 255, 0.2) 75%,
  //   transparent 75%,
  //   transparent
  // );
}

/* RTL */
.rtl-layout .sidebar {
  .sidebar-header {
    text-align: right;
    padding-top: 5px;
    padding-bottom: 0;

    .swiper-sidebar-control-btns {
      float: left !important;
    }
  }
  .news-title,
  .news-components {
    text-align: right;
    direction: rtl;
  }
  .news-footer {
    text-align: left !important;
    direction: rtl;

    i {
      transform: rotate(180deg);
    }
  }
}
</style>

<style>
.sidebar-swiper {
  width: 380px;
  overflow: hidden;
}
</style>
